var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('section',[_c('Banner')],1),_c('section',[_c('FeaturesSection')],1),_c('showcase-section'),_c('testimonials-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }